import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  useLazyGetCommentsQuery,
  useLazyPaginateFilterDiscussionsQuery,
} from "@/redux/service";
import ContentTab, { EntityDetails } from "@/components/ContentTab.jsx";
import UserForm from "./UserForm.js";
import ProfileCommentDetails from "../components/ProfileCommentDetails.jsx";
import { PrivateProfileProps } from "../types/user.js";
import BaseTabs from "@/components_v2/Tabs/BaseTabs.js";
import ProfileTypeForms from "@/views/profiles/components/ProfileTypeForms";

import "./styles.css";

const PrivateProfile = ({ userId }: PrivateProfileProps) => {
  const { t } = useTranslation();

  const tabs = useMemo(
    () => [
      {
        label: t("profiles.about"),
        key: "about",
        children: <ProfileTypeForms />,
      },
      {
        label: t("profiles.discussions"),
        key: "communityDiscussions",
        children: (
          <ContentTab
            filters={{ createdBy: userId }}
            getPaginatedContent={useLazyPaginateFilterDiscussionsQuery}
            // @ts-expect-error suppressing until ContentTab is moved to TS
            orderingField="published"
            renderComponent={(discussion: any) => (
              <EntityDetails entity={discussion} path="/discussions" />
            )}
          />
        ),
      },
      {
        label: t("profiles.comments"),
        key: "communityComments",
        children: (
          <ContentTab
            filters={{ createdBy: userId }}
            getPaginatedContent={useLazyGetCommentsQuery}
            // @ts-expect-error suppressing until ContentTab is moved to TS
            orderingField="created_at"
            renderComponent={(comment: any) => (
              <ProfileCommentDetails entity={comment} />
            )}
          />
        ),
      },
    ],
    [userId, t],
  );

  return (
    <div className="private-profile">
      <UserForm userId={userId} />

      <BaseTabs defaultActiveKey="about" items={tabs} />
    </div>
  );
};

export default PrivateProfile;
